export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_BENEFITS = "GET_CATEGORIES_BENEFITS";
export const GET_CATEGORY_TYPE = "GET_CATEGORY_TYPE";
export const GET_SUBCATEGORIES = "GET_SUBCATEGORIES"; 
export const GET_STATE_LOADING = "GET_STATE_LOADING";  
export const GET_MODO = "GET_MODO";
export const GET_CATEGORIES_ID = "GET_CATEGORIES_ID";
